import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=38555eaf&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=js&"
export * from "./resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=38555eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38555eaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38555eaf')) {
      api.createRecord('38555eaf', component.options)
    } else {
      api.reload('38555eaf', component.options)
    }
    module.hot.accept("./resetPassword.vue?vue&type=template&id=38555eaf&scoped=true&", function () {
      api.rerender('38555eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/resetPassword.vue"
export default component.exports